var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRepeater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.12,10.83l3.2,3.84a.5.5,0,0,0,.8,0l2.79-4.15a.5.5,0,1,0-.83-.56l-1.6,2.38a9.06,9.06,0,0,0-1.3-4.84,9.48,9.48,0,0,0-5.91-4.37,9,9,0,0,0-8.81,2.8.5.5,0,1,0,.75.66,8,8,0,0,1,7.84-2.48A8.48,8.48,0,0,1,19.33,8a8,8,0,0,1,1.08,5.24l-2.52-3a.5.5,0,0,0-.77.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.51,14.22a.5.5,0,1,0,.83.56l1.78-2.65a9.15,9.15,0,0,0,7,8.48,9,9,0,0,0,8.4-2.35.5.5,0,0,0-.7-.71,8,8,0,0,1-7.47,2.09,8.23,8.23,0,0,1-6.24-8l2.41,2.88a.5.5,0,0,0,.77-.64L4.17,10.11a.51.51,0,0,0-.87,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9 h6 v6 h-6 v6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepeater);
export default __webpack_public_path__ + "static/media/icon_repeater.332d3bd00fcb548baa1bc9e11f4acdc0.svg";
export { ForwardRef as ReactComponent };